module.exports = __webpack_public_path__ + "static/img/花瓶14.7a9929a.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/reliefVase/imgs/花瓶14.png
// module id = Mry2
// module chunks = 2